// app27 — интерактив темы (редизайн 2026). IIFE, без jQuery,
// инициализация по data-*-атрибутам.
(function () {
  'use strict';

  // Экранирование значений, попадающих в innerHTML.
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Слайдер шагов на странице «Магазин» (мобайл): нативный скролл
  // со scroll-snap; стрелки и точки синхронизируются с позицией прокрутки.
  function initStepsSliders() {
    var sliders = document.querySelectorAll('[data-steps-slider]');

    Array.prototype.forEach.call(sliders, function (root) {
      var viewport = root.querySelector('.steps-slider__viewport');
      var track = root.querySelector('.steps-slider__track');
      var slides = root.querySelectorAll('.steps-slide');
      var prev = root.querySelector('.steps-slider__arrow--prev');
      var next = root.querySelector('.steps-slider__arrow--next');
      var dots = root.querySelectorAll('.steps-slider__dot');
      var raf = 0;

      if (!viewport || !track || slides.length < 2) {
        return;
      }

      function stepSize() {
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;

        return slides[0].offsetWidth + gap;
      }

      function activeIndex() {
        return Math.round(viewport.scrollLeft / stepSize());
      }

      function goTo(index) {
        var target = Math.max(0, Math.min(slides.length - 1, index));

        viewport.scrollTo({ left: target * stepSize(), behavior: 'smooth' });
      }

      function syncDots(index) {
        Array.prototype.forEach.call(dots, function (dot, k) {
          dot.classList.toggle('is-active', k === index);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(activeIndex() - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          goTo(activeIndex() + 1);
        });
      }

      Array.prototype.forEach.call(dots, function (dot, k) {
        dot.addEventListener('click', function () {
          goTo(k);
        });
      });

      viewport.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          syncDots(activeIndex());
        });
      }, { passive: true });
    });
  }

  // Оверлей-меню шапки (мобайл): бургер открывает, крестик/Esc закрывает.
  function initMenuOverlay() {
    var overlay = document.getElementById('menu-overlay');
    var openBtn = document.querySelector('[data-menu-open]');
    var closeBtn = overlay ? overlay.querySelector('[data-menu-close]') : null;

    if (!overlay || !openBtn || !closeBtn) {
      return;
    }

    function setOpen(open) {
      overlay.classList.toggle('is-open', open);
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        setOpen(true);
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setOpen(false);
      }
    });
  }

  // Кабинет продавца: клик по строке продажи раскрывает блок с деталями
  // (состав продажи). Строка — [data-sale-toggle], блок — по id из значения.
  function initSaleToggles() {
    var rows = document.querySelectorAll('[data-sale-toggle]');

    Array.prototype.forEach.call(rows, function (row) {
      var target = document.getElementById(row.getAttribute('data-sale-toggle'));

      if (!target) {
        return;
      }

      function toggle() {
        var open = target.classList.toggle('is-open');

        row.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      row.addEventListener('click', toggle);
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  // Кабинет владельца: кнопка «Приховати/Показати продавців» у карточке
  // торговой точки. Кнопка — [data-sellers-toggle] (id панели в значении),
  // тексты состояний — в data-text-show / data-text-hide.
  function initSellersToggles() {
    var buttons = document.querySelectorAll('[data-sellers-toggle]');

    Array.prototype.forEach.call(buttons, function (btn) {
      var panel = document.getElementById(btn.getAttribute('data-sellers-toggle'));
      var label = btn.querySelector('span');

      if (!panel) {
        return;
      }

      function sync() {
        var open = panel.classList.contains('is-open');

        if (label) {
          label.textContent = open ? btn.getAttribute('data-text-hide') : btn.getAttribute('data-text-show');
        }

        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      btn.addEventListener('click', function () {
        panel.classList.toggle('is-open');
        sync();
      });

      sync();
    });
  }

  // Форма торговой точки: кнопка «+ Додати ще продавця» показывает
  // следующий скрытый блок продавца (data-seller-block).
  function initSellerBlocks() {
    var btn = document.getElementById('add-seller-btn');

    if (!btn) {
      return;
    }

    function syncButton() {
      var hidden = document.querySelectorAll('[data-seller-block].d-none');

      btn.classList.toggle('d-none', hidden.length === 0);
    }

    btn.addEventListener('click', function () {
      var blocks = document.querySelectorAll('[data-seller-block].d-none');

      if (blocks.length > 0) {
        blocks[0].classList.remove('d-none');
      }

      syncButton();
    });

    syncButton();
  }

  // Автокомплит по ЄДРПОУ: подставляет данные ТТ из справочника
  // (seller/lookup-edrpou). URL берётся из data-edrpou-lookup инпута.
  function initEdrpouLookup() {
    var input = document.querySelector('[data-edrpou-lookup]');
    var listEl = document.getElementById('edrpou-store-list');

    if (!input || !listEl) {
      return;
    }

    var lookupUrl = input.getAttribute('data-edrpou-lookup');
    var timer = null;

    function fillFields(store) {
      var legal = document.querySelector('#ownerform-legal_name');
      var name = document.querySelector('#ownerform-store_name');
      var addr = document.querySelector('#ownerform-store_address');

      if (legal) legal.value = store.legal_name || '';
      if (name) name.value = store.name || '';
      if (addr) addr.value = store.address || '';
    }

    function hideList() {
      listEl.innerHTML = '';
      listEl.classList.add('d-none');
    }

    function showList(stores) {
      var html = '<div class="edrpou-list__title">Знайдено ' + stores.length +
        ' торгов' + (stores.length === 1 ? 'у точку' : (stores.length < 5 ? 'і точки' : 'их точок')) +
        ' з таким ЄДРПОУ. Оберіть одну:</div>';

      stores.forEach(function (store, idx) {
        html += '<div class="edrpou-list__item" data-idx="' + idx + '">' +
          '<span class="edrpou-list__name">' + escapeHtml(store.name) + '</span>' +
          '<span class="edrpou-list__addr">' + (store.city ? escapeHtml(store.city) + ', ' : '') + escapeHtml(store.address) + '</span>' +
          '</div>';
      });

      listEl.innerHTML = html;
      listEl.classList.remove('d-none');

      Array.prototype.forEach.call(listEl.querySelectorAll('.edrpou-list__item'), function (item) {
        item.addEventListener('click', function () {
          var idx = parseInt(this.getAttribute('data-idx'), 10);

          fillFields(stores[idx]);
          hideList();
        });
      });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      hideList();

      var val = this.value.replace(/\D/g, '');

      if (val.length < 8) {
        return;
      }

      timer = setTimeout(function () {
        fetch(lookupUrl + '?edrpou=' + encodeURIComponent(val))
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data.length === 1) {
              fillFields(data[0]);
            } else if (data && data.length > 1) {
              fillFields(data[0]);
              showList(data);
            }
          })
          .catch(function () {});
      }, 500);
    });
  }

  // Каталог подарунків: тосты, лист бажань (добавление/удаление/сохранение).
  // URL-ы и тексты берутся из data-атрибутов корня [data-gifts-page].
  function initGiftsPage() {
    var root = document.querySelector('[data-gifts-page]');

    if (!root) {
      return;
    }

    var list = root.querySelector('#wishlist-list');
    var emptyNotice = root.querySelector('#wishlist-empty');
    var actions = root.querySelector('#wishlist-actions');
    var message = root.querySelector('.gifts-wishlist__message');

    if (!list) {
      return;
    }

    // CSRF: имя параметра — из <meta name="csrf-param">, значение — из csrf-token.
    // Токен добавляется в тело POST: Yii читает его из body или заголовка
    // X-CSRF-Token, поэтому отдельный заголовок с именем параметра не работает.
    function post(url, body) {
      var tokenMeta = document.querySelector('meta[name="csrf-token"]');
      var paramMeta = document.querySelector('meta[name="csrf-param"]');

      if (tokenMeta) {
        body += (body ? '&' : '')
          + encodeURIComponent(paramMeta ? paramMeta.getAttribute('content') : '_csrf')
          + '=' + encodeURIComponent(tokenMeta.getAttribute('content'));
      }

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (r) {
        if (!r.ok) {
          throw new Error('HTTP ' + r.status);
        }

        return r.json().catch(function () {
          throw new Error('Invalid JSON');
        });
      });
    }

    function showToast(text, type) {
      var container = document.getElementById('toast-container');

      if (!container) {
        return;
      }

      var toast = document.createElement('div');

      toast.className = 'toast-item toast-' + (type || 'success');
      toast.textContent = text;
      container.appendChild(toast);

      requestAnimationFrame(function () {
        toast.classList.add('is-shown');
      });

      setTimeout(function () {
        toast.classList.remove('is-shown');

        setTimeout(function () {
          toast.remove();
        }, 300);
      }, 3500);
    }

    // Сбой запроса: сервер ответил ошибкой (HTTP/невалидный JSON) либо
    // соединение не состоялось — сообщения разные.
    function showRequestError(err) {
      var serverFault = err && /^(HTTP |Invalid JSON)/.test(err.message);

      showToast(serverFault ? 'Помилка сервера. Спробуйте пізніше.' : "Помилка з'єднання.", 'error');
    }

    function syncWishlistState() {
      var hasItems = !!list.querySelector('.gift-card');

      if (emptyNotice) {
        emptyNotice.classList.toggle('d-none', hasItems);
      }

      if (actions) {
        actions.classList.toggle('d-none', !hasItems);
      }
    }

    function findWishlistCard(itemId) {
      var cards = list.querySelectorAll('.gift-card[data-item-id]');
      var i;

      for (i = 0; i < cards.length; i += 1) {
        if (cards[i].dataset.itemId === String(itemId)) {
          return cards[i];
        }
      }

      return null;
    }

    function createWishlistCard(sourceCard, item) {
      var card = document.createElement('article');
      var sourceImage = sourceCard ? sourceCard.querySelector('.gift-card__image') : null;
      var sourceName = sourceCard ? sourceCard.querySelector('.gift-card__name') : null;
      var sourcePoints = sourceCard ? sourceCard.querySelector('.gift-card__points') : null;
      var image = document.createElement('img');
      var title = document.createElement('h4');
      var price = document.createElement('div');
      var meta = document.createElement('div');
      var qty = document.createElement('span');
      var remove = document.createElement('button');

      card.className = 'gift-card';
      card.dataset.itemId = String(item.item_id);
      card.dataset.giftId = String(item.gift_id);

      image.className = 'gift-card__image';

      if (sourceImage) {
        image.src = sourceImage.getAttribute('src') || '';
        image.alt = sourceName ? sourceName.textContent : '';
      }

      card.appendChild(image);

      title.className = 'gift-card__name';
      title.textContent = sourceName ? sourceName.textContent : '';
      card.appendChild(title);

      price.className = 'gift-card__points';
      price.textContent = sourcePoints ? sourcePoints.textContent : '';
      card.appendChild(price);

      meta.className = 'gift-card__meta';

      if (item.size) {
        meta.appendChild(document.createTextNode('Розмір: ' + item.size + ' | '));
      }

      meta.appendChild(document.createTextNode('Кількість: '));
      qty.className = 'gift-card__qty';
      qty.textContent = item.quantity;
      meta.appendChild(qty);
      card.appendChild(meta);

      remove.type = 'button';
      remove.className = 'btn btn--secondary btn--sm w-100 gift-card__remove';
      remove.dataset.itemId = String(item.item_id);
      remove.textContent = 'Скасувати';
      card.appendChild(remove);
      bindRemoveButton(remove);

      return card;
    }

    function updateWishlistItem(item, sourceCard) {
      if (!item.item_id) {
        return;
      }

      var card = findWishlistCard(item.item_id);

      if (card) {
        var qty = card.querySelector('.gift-card__qty');

        if (qty) {
          qty.textContent = item.quantity;
        }

        return;
      }

      list.appendChild(createWishlistCard(sourceCard, item));
    }

    function bindRemoveButton(btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.gift-card');

        if (btn.disabled) {
          return;
        }

        btn.disabled = true;

        post(root.getAttribute('data-remove-url'), 'item_id=' + encodeURIComponent(btn.dataset.itemId))
          .then(function (data) {
            if (data.success) {
              card.remove();
              syncWishlistState();
              showToast('Подарунок видалено з листа бажань');
            } else {
              btn.disabled = false;
              showToast(data.message || 'Помилка.', 'error');
            }
          })
          .catch(function (err) {
            btn.disabled = false;
            showRequestError(err);
          });
      });
    }

    Array.prototype.forEach.call(list.querySelectorAll('.gift-card__remove'), bindRemoveButton);

    // Селект размера: подкрашиваем плейсхолдер, пока размер не выбран
    Array.prototype.forEach.call(root.querySelectorAll('.gift-card__size-select'), function (select) {
      select.addEventListener('change', function () {
        select.classList.toggle('is-empty', !select.value);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('.gift-card__add'), function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.gift-card');
        var hasSize = btn.dataset.hasSize === '1';
        var select = hasSize ? card.querySelector('.gift-card__size-select') : null;
        var size = null;

        if (btn.disabled) {
          return;
        }

        if (select) {
          if (!select.value) {
            showToast('Будь ласка, вкажіть розмір перед додаванням до листа бажань', 'error');
            return;
          }

          size = select.value;
        }

        btn.disabled = true;
        btn.textContent = 'Додаємо...';

        var body = 'gift_id=' + encodeURIComponent(btn.dataset.giftId);

        if (size) {
          body += '&size=' + encodeURIComponent(size);
        }

        post(root.getAttribute('data-add-url'), body)
          .then(function (data) {
            btn.disabled = false;
            btn.textContent = 'Додати у бажане';

            if (data.success) {
              updateWishlistItem(data, card);
              syncWishlistState();
              showToast('Подарунок додано до листа бажань');
            } else {
              showToast(data.message || 'Помилка.', 'error');
            }
          })
          .catch(function (err) {
            btn.disabled = false;
            btn.textContent = 'Додати у бажане';
            showRequestError(err);
          });
      });
    });

    var submitBtn = root.querySelector('#submit-wishlist-btn');

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (submitBtn.disabled) {
          return;
        }

        submitBtn.disabled = true;

        post(root.getAttribute('data-submit-url'), '')
          .then(function (data) {
            if (data.success) {
              showToast(root.getAttribute('data-msg-saved'));

              setTimeout(function () {
                window.location.href = root.getAttribute('data-redirect-url');
              }, parseInt(root.getAttribute('data-redirect-delay'), 10) || 1500);
            } else {
              if (message) {
                message.textContent = data.message || 'Помилка.';
                message.classList.add('is-visible');
              }

              submitBtn.disabled = false;
              showToast(data.message || 'Помилка.', 'error');
            }
          })
          .catch(function (err) {
            showRequestError(err);
            submitBtn.disabled = false;
          });
      });
    }

    syncWishlistState();
  }

  // Замовлення подарунків власника (/seller/gift-orders): перерахунок сум,
  // модалка доставки з валідацією, автокомплит Новой Почти, success-модалка.
  // URL-ы и лимит балов — в data-атрибутах корня [data-gift-orders-page].
  function initGiftOrdersPage() {
    var root = document.querySelector('[data-gift-orders-page]');

    if (!root) {
      return;
    }

    var availablePoints = parseInt(root.getAttribute('data-available-points'), 10) || 0;
    var npEnabled = root.getAttribute('data-np-enabled') === '1';
    var npCitiesUrl = root.getAttribute('data-np-cities-url') || '';
    var npWarehousesUrl = root.getAttribute('data-np-warehouses-url');
    var table = document.getElementById('gift-orders-table');
    var totalEl = document.getElementById('order-total');
    var warningEl = document.getElementById('order-warning');
    var confirmBtn = document.getElementById('confirm-order-btn');
    var deliveryModal = document.getElementById('delivery-modal');
    var deliveryForm = document.getElementById('delivery-form');
    var deliveryQuantities = document.getElementById('delivery-quantities');
    var deliveryValidationError = document.getElementById('delivery-validation-error');
    var deliveryCity = document.getElementById('delivery-city');
    var deliveryCityRef = document.getElementById('delivery-city-ref');
    var deliveryWarehouse = document.getElementById('delivery-warehouse');
    var deliveryRecipientName = deliveryForm ? deliveryForm.querySelector('input[name="DeliveryForm[recipient_name]"]') : null;
    var deliveryPhone = document.getElementById('delivery-phone');
    // Відділення обране зі списку; true лише якщо склад предзаповнений з замовлення
    var warehouseSelected = !!(npEnabled && deliveryWarehouse && deliveryWarehouse.value);

    function setOpen(modal, open) {
      modal.classList.toggle('d-none', !open);
      modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    // --- Перерахунок сум при зміні кількостей ---
    function recalculate() {
      if (!table) {
        return;
      }

      var total = 0;

      Array.prototype.forEach.call(table.querySelectorAll('.data-table__row[data-gift-points]'), function (row) {
        var points = parseInt(row.dataset.giftPoints, 10) || 0;
        var qtyInput = row.querySelector('.quantity-input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;

        row.querySelector('.line-sum').textContent = points * qty;
        total += points * qty;
      });

      if (totalEl) {
        totalEl.textContent = total;
      }

      if (confirmBtn) {
        confirmBtn.disabled = total > availablePoints || total === 0;
      }

      if (warningEl) {
        warningEl.classList.toggle('d-none', total <= availablePoints);
      }
    }

    function collectQuantities() {
      var q = {};

      if (table) {
        Array.prototype.forEach.call(table.querySelectorAll('.quantity-input'), function (input) {
          q[input.dataset.itemId] = input.value;
        });
      }

      return q;
    }

    if (table) {
      Array.prototype.forEach.call(table.querySelectorAll('.quantity-input'), function (input) {
        input.addEventListener('input', recalculate);
      });
    }

    // --- Модалка доставки ---
    function openDelivery() {
      if (!deliveryModal) {
        return;
      }

      if (deliveryQuantities) {
        deliveryQuantities.value = JSON.stringify(collectQuantities());
      }

      setOpen(deliveryModal, true);
    }

    function closeDelivery() {
      if (deliveryModal) {
        setOpen(deliveryModal, false);
      }
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openDelivery();
      });
    }

    var deliveryClose = document.getElementById('delivery-close');

    if (deliveryClose) {
      deliveryClose.addEventListener('click', closeDelivery);
    }

    if (deliveryModal) {
      deliveryModal.querySelector('.delivery-modal__overlay').addEventListener('click', closeDelivery);
    }

    function validateDeliveryForm() {
      [deliveryCity, deliveryWarehouse, deliveryRecipientName, deliveryPhone].forEach(function (field) {
        if (field) {
          field.classList.remove('is-invalid');
          field.removeAttribute('aria-invalid');
        }
      });
      if (deliveryValidationError) {
        deliveryValidationError.textContent = '';
        deliveryValidationError.classList.add('d-none');
      }

      function invalid(field, messageText) {
        if (field) {
          field.classList.add('is-invalid');
          field.setAttribute('aria-invalid', 'true');
        }
        if (deliveryValidationError) {
          deliveryValidationError.textContent = messageText;
          deliveryValidationError.classList.remove('d-none');
        }
        if (field && !field.disabled) {
          field.focus();
        } else if (deliveryCity) {
          deliveryCity.focus();
        }
        return false;
      }

      if (!deliveryCity || !deliveryCity.value.trim()) {
        return invalid(deliveryCity, 'Це поле має бути заповнене');
      }
      if (deliveryCity.value.length > 255) {
        return invalid(deliveryCity, 'Максимум 255 символів');
      }
      if (!deliveryWarehouse || deliveryWarehouse.disabled || !deliveryWarehouse.value.trim()) {
        return invalid(deliveryWarehouse || deliveryCity, 'Оберіть відділення/поштомат');
      }
      if (npEnabled && !warehouseSelected) {
        return invalid(deliveryWarehouse, 'Оберіть відділення/поштомат зі списку');
      }
      if (deliveryWarehouse.value.length > 255) {
        return invalid(deliveryWarehouse, 'Максимум 255 символів');
      }
      if (!deliveryRecipientName || !deliveryRecipientName.value.trim()) {
        return invalid(deliveryRecipientName, 'Це поле має бути заповнене');
      }
      if (deliveryRecipientName.value.length > 120) {
        return invalid(deliveryRecipientName, 'Максимум 120 символів');
      }
      if (!/^\S{2,}\s+\S{2,}.*$/u.test(deliveryRecipientName.value)) {
        return invalid(deliveryRecipientName, 'Введіть мінімум 2 слова');
      }
      if (!deliveryPhone || !/^\+38 \(0\d{2}\) \d{3}-\d{2}-\d{2}$/.test(deliveryPhone.value)) {
        return invalid(deliveryPhone, 'Введіть коректний номер телефону');
      }
      return true;
    }

    // При сабміті кількості з таблиці переписуються в hidden-поля форми
    if (deliveryForm) {
      deliveryForm.addEventListener('submit', function (e) {
        if (!validateDeliveryForm()) {
          e.preventDefault();
          return;
        }
        var q = collectQuantities();
        var html = '';
        for (var id in q) {
          if (q.hasOwnProperty(id)) {
            html += '<input type="hidden" name="quantities[' + id + ']" value="' + q[id] + '">';
          }
        }
        if (deliveryQuantities) {
          deliveryQuantities.remove();
        }
        deliveryForm.insertAdjacentHTML('afterbegin', html);
      });
    }

    // --- Автокомплит Новой Почты (город + отделение) ---
    if (npEnabled) {
      var currentCityRef = root.getAttribute('data-initial-city-ref') || '';
      var csrfTokenMeta = document.querySelector('meta[name="csrf-token"]');
      var csrfParamMeta = document.querySelector('meta[name="csrf-param"]');
      var npCsrfToken = csrfTokenMeta ? csrfTokenMeta.getAttribute('content') : '';
      var npCsrfParamName = csrfParamMeta ? csrfParamMeta.getAttribute('content') : '_csrf';

      // Fallback: CSRF из скрытого поля формы, если meta-тегов нет
      if (!npCsrfToken && deliveryForm) {
        var csrfInput = deliveryForm.querySelector('input[name$="csrf"]');
        if (csrfInput) {
          npCsrfToken = csrfInput.value;
          npCsrfParamName = csrfInput.getAttribute('name');
        }
      }

      var npDropdown = null;
      var whDropdown = null;

      function npHideSuggestions() {
        if (npDropdown) {
          npDropdown.remove();
          npDropdown = null;
        }
      }

      function npShowSuggestions(items) {
        npHideSuggestions();
        if (!items.length || !deliveryCity) { return; }
        deliveryCity.parentNode.style.position = 'relative';
        npDropdown = document.createElement('div');
        npDropdown.className = 'np-autocomplete-dropdown';
        npDropdown.style.top = (deliveryCity.offsetTop + deliveryCity.offsetHeight) + 'px';
        npDropdown.style.left = deliveryCity.offsetLeft + 'px';
        npDropdown.style.width = deliveryCity.offsetWidth + 'px';
        items.forEach(function (item) {
          var opt = document.createElement('div');
          opt.textContent = item.value;
          opt.addEventListener('click', function () {
            deliveryCity.value = item.value;
            if (deliveryCityRef) { deliveryCityRef.value = item.data; }
            npHideSuggestions();
            loadWarehouses(item.data);
          });
          npDropdown.appendChild(opt);
        });
        deliveryCity.parentNode.appendChild(npDropdown);
      }

      var npTimer = null;
      if (deliveryCity) {
        deliveryCity.addEventListener('input', function () {
          if (deliveryCityRef) { deliveryCityRef.value = ''; }
          currentCityRef = '';
          if (deliveryWarehouse) {
            deliveryWarehouse.value = '';
            deliveryWarehouse.disabled = true;
            warehouseSelected = false;
            whHideSuggestions();
          }
          var q = this.value.trim();
          if (q.length < 2) { npHideSuggestions(); return; }
          clearTimeout(npTimer);
          npTimer = setTimeout(function () {
            fetch(npCitiesUrl + '?query=' + encodeURIComponent(q), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
              .then(function (r) { return r.json(); })
              .then(function (data) { npShowSuggestions(data || []); })
              .catch(function () { npHideSuggestions(); });
          }, 300);
        });
        deliveryCity.addEventListener('blur', function () { setTimeout(npHideSuggestions, 200); });
      }

      function whHideSuggestions() {
        if (whDropdown) {
          whDropdown.remove();
          whDropdown = null;
        }
      }

      function whShowSuggestions(items) {
        whHideSuggestions();
        if (!items.length || !deliveryWarehouse) { return; }
        deliveryWarehouse.parentNode.style.position = 'relative';
        whDropdown = document.createElement('div');
        whDropdown.className = 'np-autocomplete-dropdown';
        whDropdown.style.top = (deliveryWarehouse.offsetTop + deliveryWarehouse.offsetHeight) + 'px';
        whDropdown.style.left = deliveryWarehouse.offsetLeft + 'px';
        whDropdown.style.width = deliveryWarehouse.offsetWidth + 'px';
        items.forEach(function (item) {
          var opt = document.createElement('div');
          opt.textContent = item.value;
          opt.addEventListener('click', function () {
            deliveryWarehouse.value = item.value;
            warehouseSelected = true;
            whHideSuggestions();
          });
          whDropdown.appendChild(opt);
        });
        deliveryWarehouse.parentNode.appendChild(whDropdown);
      }

      function loadWarehouses(cityRef) {
        if (!deliveryWarehouse || !cityRef) { return; }
        currentCityRef = cityRef;
        deliveryWarehouse.disabled = false;
        deliveryWarehouse.value = '';
        warehouseSelected = false;
        deliveryWarehouse.focus();
      }

      var whTimer = null;
      if (deliveryWarehouse) {
        deliveryWarehouse.addEventListener('input', function () {
          warehouseSelected = false;
          if (!currentCityRef) { whHideSuggestions(); return; }
          var q = this.value.trim();
          if (q.length < 2) { whHideSuggestions(); return; }
          clearTimeout(whTimer);
          whTimer = setTimeout(function () {
            var body = new URLSearchParams();
            body.append('cityRef', currentCityRef);
            body.append('query', q);
            body.append(npCsrfParamName, npCsrfToken);
            fetch(npWarehousesUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
              body: body.toString()
            })
              .then(function (r) { return r.json(); })
              .then(function (data) { whShowSuggestions(data || []); })
              .catch(function () { whHideSuggestions(); });
          }, 300);
        });
        deliveryWarehouse.addEventListener('blur', function () { setTimeout(whHideSuggestions, 200); });
      }
    }

    recalculate();
  }

  // Success-модалка после подтверждения заказа (flash): крестик/оверлей,
  // авто-закрытие через 5с.
  function initSuccessModal() {
    var modal = document.querySelector('[data-success-modal]');

    if (!modal) {
      return;
    }

    function hide() {
      modal.classList.add('d-none');
      modal.setAttribute('aria-hidden', 'true');
    }

    Array.prototype.forEach.call(modal.querySelectorAll('[data-success-close]'), function (el) {
      el.addEventListener('click', hide);
    });

    setTimeout(hide, 5000);
  }

  // Формы закупівель/продажів (/seller/register-purchase, register-sale):
  // календар дати — показ по фокусу, позиционирование под инпутом правым
  // краем и блокировка скролла страницы, пока календарь открыт (события
  // show/hide jQuery-виджета smalot).
  function initFormDatepicker() {
    var selector = '#purchaseform-date, #saleform-date';
    var input = document.querySelector(selector);

    if (!input || !window.jQuery) {
      return;
    }

    var $ = window.jQuery;

    function positionDatepicker(input, dp) {
      var rect = input.getBoundingClientRect();

      // Панель спозиционирована absolute в body — координаты документа,
      // а getBoundingClientRect() даёт координаты вьюпорта: добавляем скролл
      dp.picker.css({
        top: rect.bottom + window.pageYOffset,
        left: rect.right + window.pageXOffset - dp.picker.outerWidth()
      });
    }

    $(document).on('focusin click', selector, function () {
      var input = $(this);
      var dp = input.data('datetimepicker');

      if (!dp) return;
      if (!dp.isVisible) dp.show();
      positionDatepicker(input[0], dp);
    });

    $(window).on('resize', function () {
      window.requestAnimationFrame(function () {
        $(selector).each(function () {
          var input = $(this);
          var dp = input.data('datetimepicker');

          if (dp && dp.isVisible) positionDatepicker(input[0], dp);
        });
      });
    });

    // Блокировка скролла, пока открыт календарь (события show/hide виджета)
    $(document).on('show', selector, function () {
      var body = document.body;

      body.dataset.datetimepickerPaddingRight = body.style.paddingRight;

      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

      if (scrollbarWidth > 0) body.style.paddingRight = scrollbarWidth + 'px';
      document.documentElement.classList.add('datetimepicker-open');
      body.classList.add('datetimepicker-open');
    });

    $(document).on('hide', selector, function () {
      var body = document.body;

      body.style.paddingRight = body.dataset.datetimepickerPaddingRight || '';
      delete body.dataset.datetimepickerPaddingRight;
      document.documentElement.classList.remove('datetimepicker-open');
      body.classList.remove('datetimepicker-open');
    });
  }

  // Селекты форм app27: подкрашиваем плейсхолдер, пока значение не выбрано
  function initFieldSelects() {
    Array.prototype.forEach.call(document.querySelectorAll('.field__select'), function (select) {
      select.classList.toggle('is-empty', !select.value);
      select.addEventListener('change', function () {
        select.classList.toggle('is-empty', !select.value);
      });
    });
  }

  initStepsSliders();

  initMenuOverlay();

  initSaleToggles();

  initSellersToggles();

  initSellerBlocks();

  initEdrpouLookup();

  initGiftsPage();

  initGiftOrdersPage();

  initSuccessModal();

  initFormDatepicker();

  initFieldSelects();
})();

